import { Injectable } from '@angular/core';
import * as _ from 'lodash-es';

import { UserService } from './core.user.service';
import { UserRest } from './core.user.rest.service';
import { GfTranslateService } from '../services/core.translate.service';
import { NotificationService } from './core.notification.service';
import { UiService } from './core.ui.service';

@Injectable()
export class LegacyKanbanService {
    private username: string = '';

    constructor(private notificationService: NotificationService, private userRest: UserRest, 
        private uiService: UiService, private userService: UserService, private gfTranslateService: GfTranslateService) {
    }

    private getIndex(list, item) {
        return _.findIndex(list, (trackerItem: any) => {
            if (item.id == trackerItem.id) {
                return true;
            }
            return false;
        });
    }

    private sendNotify(queue, todoList?) {
        var params: any = {
            queue: queue
        };
        if (todoList) {
            params.todoList = todoList;
        }
        this.notificationService.notifyAll('queue-change', params);
    }

    public isAllowedToUpdate(unixName = '', adminFlag = false) {
        if (this.userService.session.getUnixName() == unixName) return true;
        return adminFlag;
    }

    public notAllowedMessage(action) {
        var msg = (action == "add") ?
            this.gfTranslateService.translate('You are not allowed to add items to {{unixname}} To-Do', { 'unixname': this.username }) :
            this.gfTranslateService.translate('You are not allowed to remove items from {{unixname}} To-Do', { 'unixname': this.username })
            ;
        this.uiService.message.showWarning(msg, 'Not Allowed');
    }

    public addToQueue(unixName, todoList, queue, item, index) {
        var _tiIndex = this.getIndex(todoList, item);
        // Always remove from todo if found
        if (_tiIndex > -1) {
            todoList.splice(_tiIndex, 1);
        }

        // Holds whatever transaction is needed.
        var promise;

        // Has it moved in queue?  Update sort order
        var _index = this.getIndex(queue, item);
        if (_index > -1 && _index != index) {

            // Remove from the old position - it's added back in the .then call below.
            queue.splice(_index, 1);

            // Adjust the destination index, if it's larger than src index
            // because we just removed an item from the array
            if (_index < index) index--;
            
            // Add the item in at the new index
            queue.splice(index, 0, item);

            var p1 = {
                tracker_item_ids: _.map(queue, 'id').join(',')
            };

            promise = this.userRest.putQueue(unixName, p1);
        } else {
            // Added to queue
            var p2 = {
                tracker_item_id: item.id,
                sort_order: index
            };

            promise = this.userRest.postQueue(unixName, p2);

            // Add the item in at the new index
            queue.splice(index, 0, item);
        }

        promise
            .then(() => {
                this.sendNotify(queue, todoList);
            }, (response) => {
                var msg
                if (response.status == 403) {
                    msg = this.gfTranslateService.translate('You are not allowed to change items in {{unixname}} To-Do', { 'unixname': this.username });
                    this.uiService.message.showWarning(msg, 'Not Allowed');
                } else {
                    msg = this.gfTranslateService.translate('There was a problem updating items in the To-Do');
                    this.uiService.message.showWarning(msg, 'Data Error');
                }
                return false;
            });
        return item;
    }

    public removeFromQueue(unixName, todoList, queue, item, index) {
        var _tiIndex = this.getIndex(todoList, item);
        // Already in the todoList?  Do nothing
        if (_tiIndex >= 0) {
            return;
        }

        // Find position in the queue for later
        var _qIndex = this.getIndex(queue, item);

        this.userRest.removeFromQueue(unixName, { id: unixName, tracker_item_id: item.id })
            .then(() => {
                // Add to todoList
                todoList.splice(index, 0, item);

                // Remove from queue if present
                if (_qIndex > -1) {
                    queue.splice(_qIndex, 1);
                }

                // Update subs with new data
                this.sendNotify(queue, todoList);
            }, (response) => {
                var msg;
                if (response.status == 403) {
                    msg = this.gfTranslateService.translate('You are not allowed to remove items from {{unixname}} To-Do', { 'unixname': this.username });
                    this.uiService.message.showWarning(msg, 'Not Allowed');
                } else {
                    msg = this.gfTranslateService.translate('There was a problem removing items from the To-Do');
                    this.uiService.message.showWarning(msg, 'Data Error');
                }
                return false;
            });
        return item;
    }
}
